import React, { useEffect } from 'react';
import { initMetaPixel } from './lib/metaPixel';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { StatsBanner } from './components/StatsBanner';
import { ProblemSection } from './components/ProblemSection';
import { ScienceSection } from './components/ScienceSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { ResultsSection } from './components/ResultsSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-charcoal selection:bg-brand-sage selection:text-brand-forest" data-id="element-0" data-mp="28suvsrja05nu">
      <Navigation data-id="element-1" data-mp="23ti5fwt74ggi" />
      <main data-id="element-2" data-mp="3ikh8gaq64uzi">
        <Hero data-id="element-3" data-mp="3ikqy1x7ax04o" />
        <StatsBanner data-id="element-4" data-mp="3ij64a9st9l7v" />
        <ProblemSection data-id="element-5" data-mp="3ijpe138b53at" />
        <ScienceSection data-id="element-6" data-mp="3mljaezbgzl56" />
        <WhatsInsideSection data-id="element-7" data-mp="3mkrd9k285fcs" />
        <ResultsSection data-id="element-8" data-mp="3mjzsl4a6121a" />
        <PricingSection data-id="element-9" data-mp="3mjgczu7zmpqf" />
        <GuaranteeSection data-id="element-10" data-mp="3rcj7c4kla37o" />
        <FAQSection data-id="element-11" data-mp="3rdas0kcnegj6" />
        <FinalCTASection data-id="element-12" data-mp="3rcsxbs5mwadd" />
      </main>
      <Footer data-id="element-13" data-mp="5yhgo69t1c8" />
    </div>;
}